module.exports = __webpack_public_path__ + "img/reshuiqi.0067e11e.png";